import { Injectable } from '@angular/core';

// @Injectable({ providedIn: 'root' })
export class LocalizationService {
  static Dict: { [key: string]: string } | { [key: string]: any } = {};
  static L(format: string, ...params) {
    const name = LocalizationService.Dict[format] || format;
    return LocalizationService.formatStringfunction(name, ...params);
  }

  private static formatStringfunction(format: string, ...params) {
    if (params.length < 1) {
      return format;
    }
    if (format.indexOf('{') >= 0 && format.indexOf('}') > 0) {
      let replaceStr = '';
      for (let i = 0; i < params.length; i++) {
        let placeHolder = '{' + i + '}';
        if (params[i] !== undefined && params[i] !== null) {
          replaceStr = params[i].toString();
        } else {
          replaceStr = '';
        }
        format = format.replace(placeHolder, replaceStr);
      }
    } else {
      for (let param of params) {
        format += ',' + param;
      }
    }
    return format;
  }
}
